<script setup>
import { ref } from 'vue';
import { Field, useField, ErrorMessage } from 'vee-validate';
import { __ } from '@/utils';
import OtpCode from "@components/otp-code.vue";
import ResendOTP from '@components/ResendOTP.vue';

const { phone, personalId, otpType } = defineProps(['phone', 'title', 'personalId', 'otpType']);

const { handleChange } = useField('sms_validation');

const loader = ref(false);
const otpCode = ref('');

const handleOtpChange = (value) => {
    otpCode.value = value;
    handleChange(value);
}

</script>

<template>
    <div>
        <p class="send-info fz20">
            <strong>
                <div v-html="title"></div>
            </strong>
        </p>
        <div class="notice__field">
            <div class="field-code">
                <Field type="hidden" name="step" value="success" />
                <div class="field__controls">
                    <div class="field">
                        <OtpCode @changed="handleOtpChange" />
                    </div>
                </div><!-- /.field__controls -->

                <slot name="error" />

                <ResendOTP 
                    :msisdn="phone"
                    :loader="loader"
                    action="selfcare_send_otp_code"
                    :payload="{ personal_id: personalId, type: otpType }"
                    @loader="loader = $event"
                />
            </div><!-- /.field-code -->
        </div><!-- /.notice__field -->
    </div>
</template>